import React from 'react';
import { FormattedMessage } from 'react-intl';
import { RadioGroupItemWrapper } from '../../pages/SchedulingPage/components/styles';

export default function PatientStatusOption({ display, selected }) {
  return (
    <RadioGroupItemWrapper selected={selected} flex="1 0 0">
      <FormattedMessage
        id="scheduling.PatientStatusOption.patientStatusOption"
        defaultMessage={display}
      />
    </RadioGroupItemWrapper>
  );
}
